<template>
  <div class="multiple-store ">
    <p>فیلتر فروشگاه</p>
    <select @change="selectedStoreChange" class="custom-select" v-model="selectedStore">
      <option value="">نمایش همه</option>
      <option v-for="store in stores" :value="store.id">{{ store.name }}</option>
    </select>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "MultipleStore",
  data() {
    return {
      selectedStore: '',
    }
  },
  computed: {
    ...mapGetters({
      stores: 'MultipleStore/getStores'
    })
  },
  methods: {
    setFilters(value, from = 'router') {
      const routeName = this.$route.name;
      if (routeName === 'Orders') {
        this.$store.commit('ShoppingCart/setFilters', {key: 'multiple_store', value: [value]})
        if (from !== 'router') {
          this.$store.dispatch("ShoppingCart/getAllOrders")
        }
      }
      if (routeName === 'ProductsDashboard') {
        this.$store.commit("Product/setFilters", {key: "multiple_store", value: [value]});
        if (from !== 'router') {
          this.$store.dispatch("Product/setDashboardProducts")
        }
      }
    },
    selectedStoreChange(event) {
      this.selectedStore = event.target.value;
      this.setFilters(this.selectedStore, 'change')
      this.$emit('updateFilter', {multiple_store: this.selectedStore})
    }
  },
  mounted() {
    let value = this.$route.query.multiple_store;
    if (value != undefined) {
      this.selectedStore = value
      this.setFilters(value)
    }

    this.$store.dispatch('MultipleStore/getStores')
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "multiple_store", value: []});
    this.$store.commit('ShoppingCart/setFilters', {key: 'multiple_store', value: []})
  }
}
</script>

<style scoped>
.multiple-store {
  overflow-y: auto;
  height: 250px;
}
</style>